import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fun-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() public color = 'dark';

  constructor() { }

  ngOnInit() { }

}
